import { removeItem } from './removeItem';

/**
 * @module helper.array
 */

/**
 * Insert data into source and check data is not duplicated.
 * @param finder
 * @see removeItem
 */
export function insertItemWithoutDuplicated<T>(
	source: T[],
	data: T,
	finder?: (data: T) => (item: T) => boolean
): T[] {
	return [
		...(removeItem(source, data, finder)),
		data,
	];
}
